import { mdiCheckCircleOutline, mdiDownloadOutline } from '@mdi/js';
import Icon from '@mdi/react';
import React from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { ResgateParcialService } from '@services';
import { gerarComprovamenteResgateParcialPDF } from '../utils/resgate-parcial';

export const FormSuccessResgateParcial = ({
  registroResgate,
  setExibiSucesso,
}) => {
  const custom = useSelector((state) => state.configs.tema);
  const { matricula, plano, token } = useSelector((state) => state.user.data);
  const { nome } = useSelector((state) => state.user.dadosPessoais);

  // eslint-disable-next-line no-unused-vars
  function cancelarPedidoResgate() {
    const service = new ResgateParcialService();
    service
      .CancelarRegistroOpcaoResgate(registroResgate.Protocolo, matricula)
      .then((res) => {
        if (res.sucesso) {
          toast.success(res.msg);
          setExibiSucesso(false);
        } else {
          toast.error(res.msg);
        }
      });
  }

  return (
    <>
      <div className="transformacaoSuccess">
        <Icon
          path={mdiCheckCircleOutline}
          color="#FFF"
          alt="File Icon"
          size={2}
        />
        <h2>A solicitação do resgate parcial foi realizada com sucesso!</h2>
      </div>
      <div className="card">
        <div className="card-body">
          <div className="transformacaoSuccessWrapper">
            <div className="tranformacaoSuccessContent">
              <h2>
                Seu número de protocolo é:{' '}
                <strong>{registroResgate.Protocolo}</strong>
              </h2>

              <p className="tbdescription">
                <b>Status: {registroResgate.Status}</b>
              </p>

              <p className="tbdescription">
                Sua solicitação do resgate parcial foi realizada em{' '}
                {registroResgate.DataPedido} com sucesso.
              </p>
            </div>

            <div className="transformacaoSuccessLinks">
              <button
                onClick={() =>
                  gerarComprovamenteResgateParcialPDF({
                    registroResgate,
                    nome,
                    plano,
                    token,
                  })
                }
              >
                <p>
                  <Icon
                    path={mdiDownloadOutline}
                    color={custom.codCorLaranja}
                    alt="File Icon"
                    size={1.25}
                  />
                  Baixar comprovante
                </p>
              </button>
              {/* {registroResgate.Status !== 'Em Processamento' && (
                <button onClick={() => cancelarPedidoResgate()}>
                  <p>
                    <Icon
                      path={mdiCancel}
                      color={custom.codCorLaranja}
                      alt="File Icon"
                      size={1.25}
                    />
                    Cancelar solicitação
                  </p>
                </button>
              )} */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
